module.exports = __webpack_public_path__ + "static/icon-encrypted-w-83e5a86aa5ac5ebc26f7e336db11f0a8.png";